<div class="header">
  <div class="title">
    <div class="left">
      <button
        sui-icon-button
        *ngIf="
          _openedFrom !== 'user-details' &&
          _openedFrom !== 'reading-mode-small-popup' &&
          _openedFrom !== 'alert'
        "
        (click)="_onBackButtonClick()"
      >
        <sui-icon name="원형 이동_왼쪽"></sui-icon>
      </button>
      <h2>댓글 목록</h2>
    </div>
    <div class="right">
      <button sui-icon-button (click)="_onCloseButtonClick()">
        <sui-icon name="엑스"></sui-icon>
      </button>
    </div>
  </div>
</div>
<div class="panel">
  <div class="total-count" [class.short]="_hiddenCount === 0">
    총 <b>{{ _total }}</b
    >개 전체 댓글/답글
  </div>
  <p class="hidden-count" *ngIf="_hiddenCount > 0">
    ({{ _hiddenCount }}개의 숨김/차단된 댓글이 있습니다)
  </p>

  <div class="content-container" #contentContainer>
    <div class="memo-content" *ngIf="_memo" [class.short]="_hiddenCount === 0">
      <p>{{ _memo.text }}</p>
    </div>
    <viewer-memo
      *ngIf="_memo"
      [menu]="_memo.is_mine ? myMenu : _singleMode ? undefined : othersMenu"
      [menuData]="{ item: _memo }"
      [content]="_memo.content"
      [createdAt]="_memo.created_at"
      [updatedAt]="_memo.updated_at ?? _memo.created_at"
    >
      <viewer-memo-type
        *ngIf="_openedFrom === 'reading-mode'"
        [type]="type"
        [isPinned]="!_singleMode && !!_memo.pinned_at"
      ></viewer-memo-type>
      <button
        sui-icon-button
        viewer-memo-top-button
        class="share-button"
        *ngIf="_memo.is_mine"
        (click)="_onShareButtonClick()"
      >
        <sui-icon name="공유-1" type="solid"></sui-icon>
      </button>
      <viewer-memo-tag *ngIf="_memo.source"
        >{{ _memo.copied_at | date : 'y.MM.dd. HH:mm' }} |
        {{ _memo.source }}님의 메모 복사</viewer-memo-tag
      >
      <viewer-memo-actions>
        <button
          class="icon-button"
          [disabled]="!!_memo.is_mine && !_singleMode"
          [class.is-hidden]="_memo.is_mine && _singleMode"
          (click)="_onLikeButtonClick()"
        >
          <sui-icon
            name="추천"
            [type]="_memo.is_liked ? 'solid' : 'outline'"
          ></sui-icon>
          {{ _memo.like_count }}
        </button>
        <button
          class="icon-button"
          [disabled]="!!_memo.is_mine && !_singleMode"
          [class.is-hidden]="_singleMode"
          (click)="_onCopyToSingleModeButtonClick()"
        >
          <sui-icon name="복사" type="solid"></sui-icon>
          {{ _memo.copy_count }}
        </button>
        <!-- 댓글 추가 -->
        <button class="icon-button" (click)="_openCommentInputBox()">
          댓글 달기
        </button>
      </viewer-memo-actions>

      <viewer-memo-author
        [avatarImageURL]="_memo.author.avatar_image_url"
        [name]="_memo.author.nickname"
        [isOnline]="_isAuthorOnline"
        (authorClick)="!_memo.is_mine && _onAuthorClick(_memo.author.id)"
        [class.is-clickable]="!_memo.is_mine"
      >
      </viewer-memo-author>
    </viewer-memo>

    <!-- 댓글 답글 목록 -->
    <div class="comment-list">
      <div class="comment-item" *ngFor="let comment of _comments" let i="index">
        <div class="divider"></div>

        <!-- 댓글 아이템 -->
        <div
          class="comment-content-container"
          [attr.data-comment-id]="comment.id"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="12"
            viewBox="0 0 9 7"
            fill="none"
          >
            <path
              d="M8.4834 4.64844V6.26074H0.802734V0.0654297H2.85938V4.64844H8.4834Z"
              fill="black"
            />
          </svg>
          <div class="comment-content-container-right">
            <div
              class="comment-content"
              [class.blinded]="comment.is_blinded"
              [class.selected]="_selectedCommentForChange === comment.id"
            >
              <!-- 더보기 버튼을 오른쪽 상단에 배치 -->
              <div class="top-buttons">
                <button
                  sui-icon-button
                  class="more-button"
                  [cdkMenuTriggerFor]="
                    comment.is_mine ? commentMyMenu : commentOthersMenu
                  "
                  [cdkMenuTriggerData]="{ comment: comment }"
                  (click)="
                    $event.stopPropagation(); _onCommentMenuOpen(comment)
                  "
                >
                  <sui-icon name="더보기"></sui-icon>
                </button>
              </div>

              <div class="text">
                <div class="date">
                  {{
                    !comment.updated_at
                      ? (comment.created_at | date : 'y.MM.dd. HH:mm')
                      : (comment.updated_at | date : 'y.MM.dd. HH:mm')
                  }}
                  {{ comment.updated_at ? '(수정됨)' : '' }}
                </div>
                <span>{{ comment.content }}</span>
              </div>
              <div class="info">
                <div class="actions">
                  <button
                    class="icon-button"
                    (click)="_onLikeCommentButtonClick(comment.id)"
                    [disabled]="comment.is_mine"
                  >
                    <sui-icon
                      name="추천"
                      [type]="comment.is_liked ? 'solid' : 'outline'"
                    ></sui-icon>
                    {{ comment.like_count }}
                  </button>
                  <!-- 댓글 추가 -->
                  <button
                    class="icon-button"
                    (click)="_openReplyInputBox(comment.id)"
                  >
                    답글 달기
                  </button>
                </div>
                <div class="author">
                  <viewer-memo-author
                    [avatarImageURL]="comment.author.avatar_image_url"
                    [name]="comment.author.nickname"
                    [isOnline]="_isAuthorOnline"
                    (authorClick)="
                      !comment.is_mine && _onAuthorClick(comment.author.id)
                    "
                    [class.is-clickable]="!comment.is_mine"
                  >
                  </viewer-memo-author>
                </div>
              </div>
              <div class="comment-blinded" *ngIf="comment.is_blinded">
                신고로 인해 숨김 처리된 게시글입니다.
              </div>
            </div>
          </div>
        </div>

        <!-- 답글 아이템 -->
        <div class="reply-container">
          <div class="reply-list" *ngFor="let reply of comment.replies">
            <div class="reply-item-container" [attr.data-comment-id]="reply.id">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="12"
                viewBox="0 0 9 7"
                fill="none"
              >
                <path
                  d="M8.4834 4.64844V6.26074H0.802734V0.0654297H2.85938V4.64844H8.4834Z"
                  fill="black"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="12"
                viewBox="0 0 9 7"
                fill="none"
              >
                <path
                  d="M8.4834 4.64844V6.26074H0.802734V0.0654297H2.85938V4.64844H8.4834Z"
                  fill="black"
                />
              </svg>
              <div class="reply-content-container-right">
                <div
                  class="reply-content"
                  [class.blinded]="reply.is_blinded"
                  [class.selected]="_selectedCommentForChange === reply.id"
                >
                  <!-- 더보기 버튼을 오른쪽 상단에 배치 -->
                  <div class="top-buttons">
                    <button
                      sui-icon-button
                      class="more-button"
                      [cdkMenuTriggerFor]="
                        reply.is_mine ? replyMyMenu : replyOthersMenu
                      "
                      [cdkMenuTriggerData]="{ comment: comment }"
                      (click)="
                        $event.stopPropagation(); _onCommentMenuOpen(reply)
                      "
                    >
                      <sui-icon name="더보기"></sui-icon>
                    </button>
                  </div>

                  <div class="text">
                    <div class="date">
                      {{
                        !reply.updated_at
                          ? (reply.created_at | date : 'y.MM.dd. HH:mm')
                          : (reply.updated_at | date : 'y.MM.dd. HH:mm')
                      }}
                      {{ reply.updated_at ? '(수정됨)' : '' }}
                    </div>
                    <span
                      ><span
                        class="mention-highlight"
                        *ngIf="reply.mention"
                        (click)="_onAuthorClick(reply.mention.id)"
                        >&commat;{{ reply.mention.nickname }} &nbsp;&nbsp;</span
                      >{{ reply.content }}</span
                    >
                  </div>
                  <div class="info">
                    <div class="actions">
                      <button
                        class="icon-button"
                        (click)="
                          _onLikeReplyButtonClick(reply.comment_id, reply.id)
                        "
                        [disabled]="reply.is_mine"
                      >
                        <sui-icon
                          name="추천"
                          [type]="reply.is_liked ? 'solid' : 'outline'"
                        ></sui-icon>
                        {{ reply.like_count }}
                      </button>
                      <!-- 댓글 추가 -->
                      <button
                        class="icon-button"
                        (click)="_openReplyInputBox(comment.id, reply.id)"
                      >
                        답글 달기
                      </button>
                    </div>
                    <div class="author">
                      <viewer-memo-author
                        [avatarImageURL]="reply.author.avatar_image_url"
                        [name]="reply.author.nickname"
                        [isOnline]="_isAuthorOnline"
                        (authorClick)="
                          !reply.is_mine && _onAuthorClick(reply.author.id)
                        "
                        [class.is-clickable]="!reply.is_mine"
                      >
                      </viewer-memo-author>
                    </div>
                  </div>
                  <div class="comment-blinded" *ngIf="reply.is_blinded">
                    신고로 인해 숨김 처리된 게시글입니다.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 댓글 입력 박스 -->
    <div
      class="comment-input-box"
      *ngIf="
        _inputFormType === 'comment' || _inputFormType === 'initial-comment'
      "
    >
      <div class="textarea-container">
        <textarea
          data-component="comment-right-panel"
          type="text"
          placeholder="댓글을 입력해 주세요."
          [value]="_inputValue"
          (input)="onInput($event)"
          (keydown)="onKeyDown($event, 'comment')"
          (focus)="onTextareaFocus($event)"
          (blur)="onTextareaBlur($event)"
        ></textarea>
        <div class="char-counter">{{ _inputValue.length }}/200</div>
      </div>
      <div class="buttons">
        <button
          class="cancel-button desktop-only"
          (click)="_onCancelButtonClick()"
        >
          취소하기
        </button>
        <button
          (click)="_onSubmitButtonClick()"
          [class.is-disabled]="!_inputValue.trim()"
        >
          등록하기
        </button>
      </div>
    </div>

    <!-- 댓글 수정 박스 -->
    <div class="comment-input-box" *ngIf="_inputFormType === 'comment-change'">
      <div class="textarea-container">
        <textarea
          data-component="comment-right-panel"
          type="text"
          placeholder="댓글을 입력해 주세요."
          [value]="_inputValue"
          (input)="onInput($event)"
          (keydown)="onKeyDown($event, 'comment-change')"
          (focus)="onTextareaFocus($event)"
          (blur)="onTextareaBlur($event)"
        ></textarea>
        <div class="char-counter">{{ _inputValue.length }}/200</div>
      </div>
      <div class="buttons">
        <button (click)="_onCancelButtonClick()" class="cancel-button">
          취소하기
        </button>
        <button
          (click)="_onChangeCommentButtonClick()"
          [class.is-disabled]="
            _inputValue === _changeInputValue || !_inputValue.trim()
          "
        >
          수정하기
        </button>
      </div>
    </div>

    <!-- 답글 입력 박스 -->
    <div class="reply-input-box" *ngIf="_inputFormType === 'reply'">
      <div class="textarea-container">
        <div
          class="nickname-indent"
          #nicknameElement
          *ngIf="!_selectedCommentForMenu?.is_mine"
        >
          &commat;{{ _selectedCommentForMenu?.author?.nickname }}
        </div>

        <textarea
          data-component="comment-right-panel"
          type="text"
          placeholder="답글을 입력해 주세요."
          [value]="_inputValue"
          (input)="onInput($event)"
          (keydown)="onKeyDown($event, 'reply')"
          (focus)="onTextareaFocus($event)"
          (blur)="onTextareaBlur($event)"
          [style.text-indent]="getNicknameIndent()"
        ></textarea>
        <div class="char-counter">{{ _inputValue.length }}/200</div>
      </div>
      <div class="buttons">
        <button
          class="cancel-button desktop-only"
          (click)="_onCancelButtonClick()"
        >
          취소하기
        </button>
        <button
          (click)="_onSubmitReplyButtonClick()"
          [class.is-disabled]="!_inputValue.trim()"
        >
          등록하기
        </button>
      </div>
    </div>

    <!-- 답글 수정 박스 -->
    <div class="reply-input-box" *ngIf="_inputFormType === 'reply-change'">
      <div class="textarea-container">
        <div
          class="nickname-indent"
          #nicknameElement
          *ngIf="_selectedCommentForMenu?.mention"
        >
          &commat;{{ _selectedCommentForMenu?.mention?.nickname }}
        </div>
        <textarea
          data-component="comment-right-panel"
          type="text"
          placeholder="답글을 입력해 주세요."
          [value]="_inputValue"
          (input)="onInput($event)"
          (keydown)="onKeyDown($event, 'reply-change')"
          (focus)="onTextareaFocus($event)"
          (blur)="onTextareaBlur($event)"
          [style.text-indent]="getNicknameIndent()"
        ></textarea>
        <div class="char-counter">{{ _inputValue.length }}/200</div>
      </div>
      <div class="buttons">
        <button (click)="_onCancelButtonClick()" class="cancel-button">
          취소하기
        </button>
        <button
          (click)="_onChangeReplyButtonClick()"
          [class.is-disabled]="
            _inputValue === _changeInputValue || !_inputValue.trim()
          "
        >
          수정하기
        </button>
      </div>
    </div>

    <!-- 메모 메뉴 템플릿 추가 -->
    <ng-template #myMenu>
      <sui-menu class="viewer-memo-menu" cdkMenu>
        <button
          sui-menu-item
          cdkMenuItem
          *ngIf="!_memo!.is_blinded && !_memo!.copied_at"
          (click)="_onEditMenuClick(_memo!)"
        >
          수정하기
        </button>
        <button sui-menu-item cdkMenuItem (click)="_onDeleteMenuClick()">
          삭제하기
        </button>
        <button
          sui-menu-item
          cdkMenuItem
          *ngIf="!_memo!.is_blinded && !_memo!.copied_at"
          (click)="_onExportMenuClick(_memo!)"
        >
          내보내기
        </button>
        <button sui-menu-item cdkMenuItem (click)="_onCopyMenuClick(_memo!)">
          복사하기
        </button>
      </sui-menu>
    </ng-template>

    <ng-template #othersMenu>
      <sui-menu cdkMenu>
        <button sui-menu-item cdkMenuItem (click)="_onReportMenuClick()">
          메모/회원 신고하기
        </button>
        <button sui-menu-item cdkMenuItem (click)="_onBlindMenuClick()">
          메모 숨기기
        </button>
      </sui-menu>
    </ng-template>

    <!-- 댓글 메뉴 템플릿 추가 -->
    <ng-template #commentMyMenu>
      <sui-menu class="viewer-comment-menu" cdkMenu>
        <button
          sui-menu-item
          cdkMenuItem
          *ngIf="!_selectedCommentForMoreButton?.is_blinded"
          (click)="_onEditCommentMenuClick()"
        >
          수정하기
        </button>
        <button
          sui-menu-item
          cdkMenuItem
          (click)="_onDeleteCommentButtonClick()"
        >
          삭제하기
        </button>
      </sui-menu>
    </ng-template>

    <ng-template #commentOthersMenu>
      <sui-menu class="viewer-comment-menu" cdkMenu>
        <button sui-menu-item cdkMenuItem (click)="_onReportCommentMenuClick()">
          댓글/회원 신고하기
        </button>
        <button sui-menu-item cdkMenuItem (click)="_onBlockCommentMenuClick()">
          댓글 숨기기
        </button>
      </sui-menu>
    </ng-template>

    <!-- 답글 메뉴 템플릿 추가 -->
    <ng-template #replyMyMenu>
      <sui-menu class="viewer-reply-menu" cdkMenu>
        <button
          sui-menu-item
          cdkMenuItem
          (click)="_onEditReplyMenuClick()"
          *ngIf="!_selectedCommentForMoreButton?.is_blinded"
        >
          수정하기
        </button>
        <button sui-menu-item cdkMenuItem (click)="_onDeleteReplyButtonClick()">
          삭제하기
        </button>
      </sui-menu>
    </ng-template>

    <ng-template #replyOthersMenu>
      <sui-menu class="viewer-reply-menu" cdkMenu>
        <button sui-menu-item cdkMenuItem (click)="_onReportCommentMenuClick()">
          답글/회원 신고하기
        </button>
        <button sui-menu-item cdkMenuItem (click)="_onBlockReplyMenuClick()">
          답글 숨기기
        </button>
      </sui-menu>
    </ng-template>
  </div>
</div>
